<nav id="header" class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/">
    <img src="/assets/images/sesera-logo.svg" class="navImage"
      alt="">
  </a>

  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=""
    aria-controls="navbarSupportedContent" aria-expanded="false" (click)="showMobileNav = true" >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto ml-auto">
      <li class="nav-item">
        <a class="nav-link nav-link-active" id="immobilie" routerLink="/">Immobilien</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/mieter" id="mieter">Für Mieter</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/kontakt" id="kontakt">Kontakt</a>
      </li>
      <li class="nav-item" *ngIf="showAdmin">
        <a class="nav-link" routerLink="/admin">Admin</a>
      </li>
    </ul>
    <div class="pseudoSpaceRigth">
      <div></div>
    </div>
  </div>
</nav>

<app-fe-nav-mobile (onClose)="openSite($event)" *ngIf="showMobileNav"></app-fe-nav-mobile>
<!--    Made by Erik Terwan    -->
<!--   24th of November 2015   -->
<!--        MIT License        -->
<!--nav role="navigation" >
  <div id="menuToggle">
    
    <input type="checkbox" />
    
    
    <span></span>
    <span></span>
    <span></span>
    
    <ul id="menu">
      <a href="#"><li>Home</li></a>
      <a href="#"><li>About</li></a>
      <a href="#"><li>Info</li></a>
      <a href="#"><li>Contact</li></a>
      <a href="https://erikterwan.com/" target="_blank"><li>Show me more</li></a>
    </ul>
  </div>
</nav-->